import React, { useEffect } from "react";
import { withRouter } from "../_shared/withRouter";
import LoginComponent from "../template/auth/loginComponent";
import { globalLoader } from "../actions/commonActions";

const UserLogin = () => {
  useEffect(() => {
    globalLoader(false);
  }, []);
  return <LoginComponent roleType={"user"} role={"3"} />;
};

export default withRouter(UserLogin);
